import { Grid, Paper } from '@mui/material';
import BannerCH from './banner-ch';

const OnBoardingLayout = (props: any) => {
  const { children } = props;

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <BannerCH />
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (t) => (t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900]),
        }}
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={6}
        square
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default OnBoardingLayout;
